import React from 'react';

export interface MobileDataCardField {
  label: string;
  value: React.ReactNode;
}

export interface MobileDataCardProps {
  fields: MobileDataCardField[];
  actions?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

const MobileDataCard: React.FC<MobileDataCardProps> = ({ fields, actions, onClick, className }) => {
  const isClickable = typeof onClick === 'function';

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick!();
    }
  };

  return (
    <div
      className={[
        'bg-slate-800 rounded-lg p-4 border border-slate-700/50',
        isClickable ? 'cursor-pointer hover:bg-slate-700/50 transition-colors min-h-[44px]' : '',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={isClickable ? onClick : undefined}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={isClickable ? handleKeyDown : undefined}
    >
      {fields.map((field, i) => (
        <div key={i} className="flex justify-between items-center py-1">
          <span className="text-slate-400 text-sm">{field.label}</span>
          <span className="text-slate-100 font-medium text-sm">{field.value}</span>
        </div>
      ))}

      {actions && (
        <div className="border-t border-slate-700/50 mt-2 pt-2">
          {actions}
        </div>
      )}
    </div>
  );
};

export default MobileDataCard;
